/**
 * PDP automatic offer — copy coupon code to clipboard.
 */
(function () {
  function copyWithFallback(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }

    return new Promise(function (resolve, reject) {
      var textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.documentElement.appendChild(textarea);
      textarea.select();
      var ok = false;
      try {
        ok = document.execCommand('copy');
      } catch (error) {
        ok = false;
      }
      document.documentElement.removeChild(textarea);
      if (ok) resolve();
      else reject(new Error('copy failed'));
    });
  }

  document.addEventListener(
    'click',
    function (event) {
      var btn = event.target.closest('[data-offer-pdp-code]');
      if (!btn || btn.dataset.skippCopyLock === '1') return;

      var code = btn.getAttribute('data-offer-code') || btn.textContent.trim();
      if (!code) return;

      event.preventDefault();
      btn.dataset.skippCopyLock = '1';

      var live = btn.closest('[data-offer-unlock]')?.querySelector('[data-offer-pdp-copy-live]');
      var badge = btn.querySelector('[data-offer-pdp-badge]');
      var originalLabel = badge ? badge.textContent : code;

      copyWithFallback(code)
        .then(function () {
          btn.classList.add('skipp-pdp-offer-showcase__code--copied');
          if (badge) badge.textContent = 'Copied!';
          if (live) live.textContent = 'Coupon code copied to clipboard';
          window.setTimeout(function () {
            btn.classList.remove('skipp-pdp-offer-showcase__code--copied');
            if (badge) badge.textContent = originalLabel;
            if (live) live.textContent = '';
            delete btn.dataset.skippCopyLock;
          }, 1800);
        })
        .catch(function () {
          if (live) live.textContent = 'Unable to copy. Try selecting the code manually.';
          window.setTimeout(function () {
            if (live) live.textContent = '';
            delete btn.dataset.skippCopyLock;
          }, 2400);
        });
    },
    true
  );
})();
